const $ = window.Bliss
const $$ = $.$

export function initJobListings() {
  const widgets = $$(".job-listings-widget")

  widgets.forEach((widget) => {
    const container = widget.querySelector(".job-listings-container")
    const loadButton = widget.querySelector(".job-listings-load-button")
    const loadingText = widget.querySelector(".job-listings-loading")
    const apiUrl = widget.dataset.url

    let currentOffset = 0
    let limit = 5 // Initial load
    let hasMore = true

    function createJobElement(job) {
      const jobDiv = document.createElement("a")
      jobDiv.href = job.url
      jobDiv.target = "_blank"
      jobDiv.rel = "noopener"
      jobDiv.className = "grid-x grid-padding-x job-listing-item"
      jobDiv.style.cursor = "pointer"

      jobDiv.innerHTML = `
        <div class="cell small-12">
          <h3 class="job-title">
            ${job.title}
          </h3>
          <div class="job-company">
            <strong>${job.company_name}</strong> • ${job.company_location_city}
          </div>
          <div class="job-category">
            ${job.category}
          </div>
          <div class="job-date">
            Veröffentlicht am ${job.published_on_formatted}
          </div>
        </div>
      `

      return jobDiv
    }

    function loadJobs() {
      loadingText.style.display = "block"
      loadButton.style.display = "none"

      fetch(`${apiUrl}?limit=${limit}&offset=${currentOffset}`)
        .then((response) => response.json())
        .then((data) => {
          loadingText.style.display = "none"

          if (data.results && data.results.length > 0) {
            data.results.forEach((job) => {
              container.appendChild(createJobElement(job))
            })

            currentOffset += data.results.length
            hasMore = data.next !== null

            // After first load, increase limit for subsequent loads
            if (limit === 5) {
              limit = 20
            }

            if (hasMore) {
              loadButton.style.display = "inline-block"
            }
          } else {
            hasMore = false
          }

          if (!hasMore && container.children.length === 0) {
            container.innerHTML =
              '<div class="grid-x grid-padding-x"><div class="cell small-12 text-center"><p>No jobs available at the moment.</p></div></div>'
          }
        })
        .catch((error) => {
          console.error("Error loading jobs:", error)
          loadingText.style.display = "none"
          loadButton.style.display = "inline-block"
        })
    }

    loadButton.addEventListener("click", loadJobs)

    // Load initial jobs
    loadJobs()
  })
}
